import { useEffect, useState } from "react";

import { Checkbox } from "@newsela/angelou";
import PropTypes from "prop-types";

import QuizElaStandardsDropdown from "@/view/QuizElaStandardsDropdown";
import elaReadingSkillsMapping from "@/view/TeacherActivityContainer/utils/elaReadingSkillsMapping";
import splitReadingSkillName from "@/view/TeacherActivityContainer/utils/splitReadingSkillName";
import useReadingSkillsContext from "@/view/utils/useReadingSkillsContext/useReadingSkillsContext";
import {
  checkboxCss,
  listItemCss,
  questionCss,
} from "./QuizQuestionCheckbox.style";

const READING_SKILLS = "READING_SKILLS";
const STANDARD = "STANDARD";

const propTypes = {
  question: PropTypes.object,
  questionMetadata: PropTypes.shape({
    data: PropTypes.array,
  }),
};

const QuizQuestionCheckbox = ({ question, questionMetadata }) => {
  const standardData = questionMetadata?.data?.find(
    (dataObj) => dataObj.content_type === STANDARD,
  );
  const readingSkillData = questionMetadata?.data?.find(
    (dataObj) => dataObj.content_type === READING_SKILLS,
  );
  const splitReadingSkillTitle = splitReadingSkillName(
    readingSkillData?.data?.name,
  );
  const readingSkillTitle = elaReadingSkillsMapping[splitReadingSkillTitle]
    ? elaReadingSkillsMapping[splitReadingSkillTitle]
    : splitReadingSkillTitle;

  const {
    handleQuizQuestionSelection,
    readingSkillState,
    setReadingSkillState,
  } = useReadingSkillsContext();

  const isSkillSelected =
    readingSkillState?.[readingSkillTitle]?.[question.id]
      .isQuizQuestionSelected ?? false;
  const [isSelected, setIsSelected] = useState(isSkillSelected);

  useEffect(() => {
    setIsSelected(isSkillSelected);
  }, [isSkillSelected]);

  const onClick = () => {
    setIsSelected((prevState) => !prevState);

    if (readingSkillState[readingSkillTitle]) {
      const newState = {
        ...readingSkillState,
        [readingSkillTitle]: {
          ...readingSkillState[readingSkillTitle],
          [question.id]: {
            isQuizQuestionSelected:
              !readingSkillState[readingSkillTitle]?.[question.id]
                .isQuizQuestionSelected,
          },
        },
      };
      setReadingSkillState(newState);
      handleQuizQuestionSelection(newState);
    }
  };

  return (
    <li css={listItemCss}>
      <Checkbox
        __cssFor={{ root: checkboxCss }}
        checked={isSelected}
        label={`Question ${question.position}`}
        onClick={onClick}
      />
      <QuizElaStandardsDropdown
        id={standardData?.id}
        standard={standardData?.data}
        readingSkillTitle={readingSkillTitle}
      />
      <div
        css={questionCss}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: question.html_question }}
      />
    </li>
  );
};

QuizQuestionCheckbox.propTypes = propTypes;

export default QuizQuestionCheckbox;
